import moment from 'moment-timezone'
import _ from 'lodash'
import {formatMinsSecs} from './components/common/RenderFields'

export const live = true

export const timezone = 'Pacific/Auckland'

export const userIsAdmin = (user) => {
    return _.first(((user || {}).roles || []).filter(r => r === 'ADMINISTRATOR'))
}

export const userIsGroupAdmin = (user) => {
    return _.first(((user || {}).roles || []).filter(r => r === 'GROUP_ADMINISTRATOR'))
}

export const userIsCialIT = (user) => {
    return _.first(((user || {}).roles || []).filter(r => r === 'CIAL_IT'))
}

export const daysAgo = (d) => {
    if (!d) {return}
    const now = moment(new Date());
    const duration = moment.duration(now.diff(moment(d)));
    //console.log('daysAgo', now, moment(d), duration, duration.asDays())
    return duration.asDays();
}

export const errorCodes = {
    UnplannedTestWillBreach: 'unplanned_test_will_breach',
    UserExists: 'user_exists'
}

export const operators = {
    AirNZ: 'Air New Zealand',
    MtCook: 'Mount Cook',
    AirNelson: 'Air Nelson',
    Jetconnect: 'Jetconnect',
    Jetstar: 'Jetstar',
    MartinJetpack: 'Martin Jetpack',
    Emirates: 'Emirates',
    SA: 'Singapore Airlines',
    CA: 'China Airlines',
    SCA: 'Southern China Airlines',
    AirFiji: 'Air Fiji',
    Virgin: 'Virgin',
    Qantas: 'Qantas',
    RNZAF: 'Royal New Zealand Air Force',
    NZFD: 'New Zealand Flying Doctors',
    RAA: 'Royal Aust Airforce',
    EFA: 'Express Freighters Aust',
    Parcelair: 'Parcelair',
    CAC: 'Canterbury Aero Club',
    NASA: 'NASA',
    SAFAIR: 'SAFAIR',
    AirNationalGuard: 'Air National Guard',
    USAF: 'United States Air Force',
    USAP: 'United States Antarctic Program',
    SkyTraders: 'Sky Traders',
    Private: 'Private',
    Other: 'Other...'
}

export const statuses = {
    SCHEDULED: 'SCHEDULED',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    DELETED: 'DELETED'
}

export const aircrafts = {
    A320: 'A320',
    A320_NEO: 'A320 NEO',
    A321_NEO: 'A321 NEO',
    A330: 'A330',
    A340: 'A340',
    A350: 'A350',
    A380: 'A380',
    B734: 'B734',
    B738: 'B738',
    B747: 'B747',
    B757: 'B757',
    B767: 'B767',
    B777: 'B777',
    B788: 'B788',
    BE20: 'BE20',
    BE9L: 'BE9L',
    ATR72_500: 'ATR72-500',
    ATR72_600: 'ATR72-600',
    Q300: 'Q300',
    C17: 'C17',
    C130: 'C130',
    CVLT: 'CVLT',
    Other: 'Other...'
}

export const aircraftIsTurboProp = (aircraft) => {
    switch (aircraft) {
        case 'BE20':
        case 'BE9L':
        case 'ATR72_500':
        case 'ATR72_600':
        case 'Q300':
        case 'C17':
        case 'C130':
        case 'CVLT': return true;
        default: return false;
    }
}

export const fourEngines = (aircraft) => {
    switch (aircraft) {
        case 'A340': return true;
        case 'A380': return true;
        case 'B747': return true;
        case 'C17': return true;
        case 'C130': return true;
        default: return false;
    }
}

export const locations = {
    RunupPad: 'Ground run pad adjacent to the No 1 Hangar Taxiway A11',
    Runway11: 'Threshold Runway 11',
    TaxiwayA7: 'Taxiway A7',
    TaxiwayA2: 'Taxiway A2',
    TaxiwayA: 'Taxiway A between A11 and A2',
    No1Hangar: 'No 1 Hangar Taxiway A11',
    No3Hangar: 'No 3 Hangar group Taxiways A12 and A13',
    DomesticApron: 'Domestic Apron Area',
    InternationalApron: 'International Apron Area',
    AntarcticApron: 'Antarctic Apron Area'
}

export const headings = {
    _30: {name: '30\u00B0', value: '_30'},
    _60: {name: '60\u00B0', value: '_60'},
    _90: {name: '90\u00B0', value: '_90'},
    _120: {name: '120\u00B0', value: '_120'},
    _150: {name: '150\u00B0', value: '_150'},
    _180: {name: '180\u00B0', value: '_180'},
    _210: {name: '210\u00B0', value: '_210'},
    _240: {name: '240\u00B0', value: '_240'},
    _270: {name: '270\u00B0', value: '_270'},
    _300: {name: '300\u00B0', value: '_300'},
    _330: {name: '330\u00B0', value: '_330'},
    _360: {name: '360\u00B0', value: '_360'}
}

export const criteria = {
    Ldn65: {name: 'Ldn65', type: 'Ldn', value: 65},
    Ldn55: {name: 'Ldn55', type: 'Ldn', value: 55},
    Lmax75: {name: 'Lmax75', type: 'Lmax', value: 75}
}

export const directions = {
    West: 'West',
    East: 'East',
    North: 'North',
    South: 'South',
}

export const receivers = {
    ETCMP1: {
        name: 'ETCMP1',
        limit: criteria.Ldn65,
        direction: directions.East
    },
    ETCMP2: {
        name: 'ETCMP2',
        limit: criteria.Ldn65,
        direction: directions.East
    },
    ETCMP3: {
        name: 'ETCMP3',
        limit: criteria.Ldn65,
        direction: directions.East
    },
    ETCMP4: {
        name: 'ETCMP4',
        limit: criteria.Ldn65,
        direction: directions.North
    },
    ETCMP5: {
        name: 'ETCMP5',
        limit: criteria.Ldn65,
        direction: directions.North
    },
    ETCMP6: {
        name: 'ETCMP6',
        limit: criteria.Ldn65,
        direction: directions.West
    },
    ETCMP7: {
        name: 'ETCMP7',
        limit: criteria.Ldn65,
        direction: directions.West
    },
    ETCMP8: {
        name: 'ETCMP8',
        limit: criteria.Ldn65,
        direction: directions.West
    },
    ETCMP9: {
        name: 'ETCMP9',
        limit: criteria.Ldn55,
        direction: directions.East
    },
    ETCMP10: {
        name: 'ETCMP10',
        limit: criteria.Ldn55,
        direction: directions.East
    },
    ETCMP11: {
        name: 'ETCMP11',
        limit: criteria.Ldn55,
        direction: directions.North
    },
    ETCMP12: {
        name: 'ETCMP12',
        limit: criteria.Ldn55,
        direction: directions.North
    },
    ETCMP13: {
        name: 'ETCMP13',
        limit: criteria.Ldn55,
        direction: directions.West
    },
    ETCMP14: {
        name: 'ETCMP14',
        limit: criteria.Ldn55,
        direction: directions.West
    },
    ETCMP15: {
        name: 'ETCMP15',
        limit: criteria.Ldn55,
        direction: directions.South
    },
    ETCMP16: {
        name: 'ETCMP16',
        limit: criteria.Ldn55,
        direction: directions.South
    },
    ETCMP17: {
        name: 'ETCMP17',
        limit: criteria.Lmax75,
        direction: directions.East
    },
    ETCMP18: {
        name: 'ETCMP18',
        limit: criteria.Lmax75,
        direction: directions.East
    },
    ETCMP19: {
        name: 'ETCMP19',
        limit: criteria.Lmax75,
        direction: directions.East
    }
}


export const formatDate = (s) => {
    if (!s) {return ''}
    return moment(s).format('DD/MM/YY HH:mm')
}

export const maxPowerTested = (test, compact) => {
    if (_.some([1,2,3,4].map(i => test[`e${i}High`]))) {
        if (compact) {
            return 'High'
        }
        const d = _.sum([1,2,3,4].map(i => test[`e${i}High`] || 0))
        return `High ${formatMinsSecs(d)}`
    } else if (_.some([1,2,3,4].map(i => test[`e${i}Med`]))) {
        if (compact) {
            return 'Med'
        }
        const d = _.sum([1,2,3,4].map(i => test[`e${i}Med`] || 0))
        return `Med ${formatMinsSecs(d)}`
    }
    if (compact) {
        return 'Idle'
    }
    const d = _.sum([1,2,3,4].map(i => test[`e${i}Idle`] || 0))
    return `Idle  ${formatMinsSecs(d)}`
}

export const uppercaseInitial = (s) => {
    return `${s.charAt(0).toUpperCase()}${s.slice(1).toLowerCase()}`
}

export const renderTestFields = (test, extended, compact, overBudget, thisTestUnderBudget, showUnplanned, mappedGroups, mappedUsers) => {

    let obj = {
        ref: test.reference || (test.id || ''),
        startedAt: formatDate(test.startedAt),
        schedulerName: (test.schedulerName || (test.ownerUsername || '')).replace(',',' '),
        testerName: (test.testerName || (test.ownerUsername || '')).replace(',',' '),
        aircraft: aircrafts[test.aircraft || ''] || '',
        aircraftRegistration: (test.aircraftRegistration || '').replace(',',' '),
        power: maxPowerTested(test, compact),
        departure: formatDate(test.scheduledDeparture),
        status: uppercaseInitial(test.status || ''),
        heading: (headings[test.heading || ''] || {}).name || ''
    }

    if (!(test.antarctic || test.naturalDisaster || test.approved)) {
        if (overBudget && obj.status === 'Scheduled') {
            obj.status = thisTestUnderBudget ? 'Completion possible' : 'Breach' //Show differently if under budget?
        } else if (showUnplanned && test.unplanned && obj.status === 'Scheduled') {
            obj.status = 'Unplanned'
        }
    }

    if (extended) {

        const engines = [];
        const plannedEngines = [];
        [1,2,3,4].forEach(i => {
            ['Idle', 'Med', 'High'].forEach(p => {
                engines.push(`e${i}${p}`)
                plannedEngines.push(`plannedE${i}${p}`)
            })
        });

        //numbers
        _.forEach([
            'id',
            'duration',
            ...engines,
            'maxSimultaneousHighPower',
            //'owner',
            //'group',

            'plannedDuration',
            ...plannedEngines,
            'plannedMaxSimultaneousHighPower',
        ], k => {
            obj[k] = (test[k] || 0).toString()
        })

        //booleans
        _.forEach([
            'antarctic',
            'naturalDisaster',
            'approved',
            'unplanned',
            'runway11InUse',
            'lightMaintenance',
            'heavyMaintenance',

            'plannedRunway11InUse',
            'plannedLightMaintenance',
            'plannedHeavyMaintenance',
            'plannedUnplanned',
            'plannedAntarctic',
            'plannedNaturalDisaster',
            'plannedApproved',
            'didPrint'
        ], k => {
            obj[k] = (test[k] || false) ? 'Y' : 'N'
        })

        //strings
        _.forEach([
            'otherOperator',
            'otherAircraft',
            //'aircraftRegistration',
            'reason',
            'weather',
            'approvalDoc',

            'plannedOtherOperator',
            'plannedOtherAircraft',
            'plannedAircraftRegistration',
            'plannedReason',
            'plannedWeather',
            'plannedSchedulerName',
            'plannedTesterName',
            'plannedApprovalDoc'
        ], k => {
            obj[k] = (test[k] || '').replace(',',' ')
        })

        //dates
        _.forEach([
            'scheduledDeparture',
            'firstEngineOn',
            'lastEngineOff',

            'plannedStartedAt',
            'plannedScheduledDeparture',
            'plannedFirstEngineOn',
            'plannedLastEngineOff'
        ], k => {
            obj[k] = formatDate(test[k])
        })

        obj.group = ((mappedGroups || {})[test.group] || {}).name || ''
        obj.owner = ((mappedUsers || {})[test.owner] || {}).name || ''

        obj = {
            ...obj,
            location: locations[test.location || ''] || '',
            operator: operators[test.operator || ''] || '',

            plannedAircraft: aircrafts[test.plannedAircraft || ''] || '',
            plannedLocation: locations[test.plannedLocation || ''] || '',
            plannedHeading: (headings[test.plannedHeading || ''] || {}).name || '',
            plannedOperator: operators[test.plannedOperator || ''] || ''
        }
    }

    return obj
}

export const downloadLink = (text, filename) => {
    const blob = new Blob([text], {type:'text/csv'})

    if ((window.navigator || {}).msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, filename);
    } else {
        const downloadLink = document.createElement("a")
        downloadLink.download = filename
        downloadLink.innerHTML = "Download File"
        if (window.webkitURL != null) {
            // Chrome allows the link to be clicked // without actually adding it to the DOM.
            downloadLink.href = window.webkitURL.createObjectURL(blob)
        } else {
            // Firefox requires the link to be added to the DOM // before it can be clicked.
            downloadLink.href = window.URL.createObjectURL(blob)
            downloadLink.onclick = (event) => {
                document.body.removeChild(event.target)
            }
            downloadLink.style.display = "none"
            document.body.appendChild(downloadLink)
        }

        downloadLink.click()
    }
}



// WEBPACK FOOTER //
// ./src/constants.js